(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/background.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/background.js');
"use strict";

const {
  ImageMemo
} = svs.eInstant.shared.components;
const Background = _ref => {
  var _svs$eInstant$data$mo;
  let {
    children,
    classNames = ''
  } = _ref;
  const backgroundImg = (_svs$eInstant$data$mo = svs.eInstant.data.moduleConfig) === null || _svs$eInstant$data$mo === void 0 ? void 0 : _svs$eInstant$data$mo.lobbyContainerBackground;
  if (backgroundImg) {
    return React.createElement("div", {
      className: "tickets-einstant-background-img overflow-hidden u-position-relative ".concat(classNames)
    }, React.createElement(ImageMemo, {
      fitWrapper: true,
      image: backgroundImg
    }), children);
  }
  return React.createElement("div", {
    className: "tickets-einstant-stripe-background-container overflow-hidden ".concat(classNames)
  }, children);
};
setGlobal('svs.eInstant.shared.components.Background', Background);

 })(window);